// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"34":"Contracts","302":"Statistics","754":"ContractDetail","918":"UserProfile"}[chunkId] + "." + {"34":"6fdb864c","302":"211642f3","754":"6fdb864c","918":"6fdb864c"}[chunkId] + ".chunk.css";
};